import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageHero from "../components/PageHero";
import FadeIn from "../components/FadeIn";
import { LOGO_URL, COMPANY } from "../mock";
import useSEO from "../hooks/useSEO";

const PrimeTrade = () => {
  useSEO({
    title: "Prime Trade",
    description: "Prime Trade — the trading arm operating from Meydan Free Zone Dubai, sourcing and delivering physical commodities across agriculture, fertilizers and oil & gas.",
  });
  return (
    <main>
      <PageHero
        title="Prime Trade"
        eyebrow="Our business"
        breadcrumbs={[{ label: "About us", path: "/company" }, { label: "Prime Trade" }]}
      />

      <section className="pt-section">
        <div className="max-w-[1280px] mx-auto px-6 grid lg:grid-cols-12 gap-12 items-center">
          <FadeIn className="lg:col-span-5">
            <div className="bg-[#f6f6f6] p-10 flex items-center justify-center border border-[#ececec]">
              <img src={LOGO_URL} alt={COMPANY.name} className="w-full max-w-[320px]" />
            </div>
          </FadeIn>
          <FadeIn className="lg:col-span-7" delay={120}>
            <div className="pt-eyebrow">Prime Trade L.L.C — FZ</div>
            <h2 className="pt-h2">A trusted name in physical commodities</h2>
            <div className="pt-divider" />
            <p className="text-[15px] leading-relaxed text-[#4a4a4a] mb-4">
              Operating from the Meydan Free Zone in Dubai, Prime Trade L.L.C — FZ is the trading arm responsible for sourcing, marketing and delivering physical commodities across our five core verticals: agriculture and food, fertilizers and chemicals, minerals and raw materials, oil and gas, and textile.
            </p>
            <p className="text-[15px] leading-relaxed text-[#4a4a4a] mb-4">
              Our trading desks combine local origin knowledge with deep relationships across the buy- and sell-side. We finance, freight, store and deliver — every day, in every region we operate.
            </p>
            <div className="grid sm:grid-cols-2 gap-4 mt-8">
              <div className="border-l-2 border-[#e30613] pl-5">
                <div className="text-[36px] font-bold text-[#2c2c2c] leading-none">5</div>
                <div className="text-xs uppercase tracking-[0.06em] text-[#7a7a7a] mt-2 font-medium">Commodity verticals</div>
              </div>
              <div className="border-l-2 border-[#e30613] pl-5">
                <div className="text-[36px] font-bold text-[#2c2c2c] leading-none">30+</div>
                <div className="text-xs uppercase tracking-[0.06em] text-[#7a7a7a] mt-2 font-medium">Countries served</div>
              </div>
            </div>
            <Link to="/catalog" className="btn-red mt-10">Explore catalog <ArrowRight size={14} /></Link>
          </FadeIn>
        </div>
      </section>
    </main>
  );
};

export default PrimeTrade;
